import React, { useEffect, useState } from "react";
import OffCanvasModal from "../../components/OffCanvasModal";
import ProviderGridItem from "./components/ProviderGridItem";
import ImageInput from "../../components/ImageInput";
import CropPopup from "../../components/CropPopup";
import ConfirmationPopup from "../../components/ConfirmationPopup";
import LoaderImage from "../../images/ohhto-loading.gif";
import axios from "../../helpers/axios";
import { dataURItoBlob, getNameFromSettings } from "../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  IMAGE_BASE_URL,
  SETTINGS_APPROVAL_TIME_LIST,
  SETTINGS_LOAN_PROVIDERS_LIST,
  SETTINGS_LTV_LIST,
  SORT_KEY_RECENT,
  SORT_ORDER_DESC,
} from "../../helpers/constants";
import PrimaryHeader from "../../components/PrimaryHeader";
import Input from "../../components/Input";
import CustomSelect from "../../components/CustomSelect";
import Moment from "moment";
import { ThemeProvider, createTheme } from "@mui/material";
import { setFilters } from "../../redux/slice/loanProviderSlice";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import LoaderComp from "../../components/LoaderComp";

export default function LoanProvider() {
  const location = useLocation();
  const pagePermission = location.state;
  //console.log("PAGE", pagePermission);
  const dispatch = useDispatch();
  const activeFilter = useSelector(
    (state) => state.loanproviderFilter?.activeFilter
  );
  const [anchorEls, setAnchorEls] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [showManageModal, setShowManageModal] = useState(false);
  const [isUpddate, setIsUpdate] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  // const [showFeatureModal,setShowFeatureModal] = useState(false)
  const [featureModal, setFeatureModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [inactiveModal, setInactiveModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: null,
    status: null,
  });
  const [tabData, setTabData] = useState([]);
  const [activeTab, setActiveTab] = useState(activeFilter);
  const [searchText, setSearchText] = useState(null);
  const [sort, setSort] = useState({
    sortKey: SORT_KEY_RECENT,
    sortOrder: SORT_ORDER_DESC,
  });

  const [tabFilterData, setTabFilterData] = useState([]);

  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [pageSize, setPageSize] = useState(24);

  const Reset = () => {
    setCurrentPage(1);
    setTabFilterData([]);
  };

  async function getProviders(page, scrollX, scrollY) {
    //console.log("activeTab", scrollX, scrollY);
    setLoading(true);
    let res = await axios.post(
      `/admin/loan/provider/list/${pageSize}/${
        page !== undefined ? page : currentPage
      }`,
      {
        keyword: searchText,
        sortKey: sort.sortKey,
        sortOrder: sort.sortOrder,
        [`${activeTab.parameter}`]: activeTab.value,
      }
    );
    window.scrollTo(scrollX, scrollY);
    setTimeout(() => {
      setItems(res.data.data);
      setTabData(res.data.counts);
      setTabFilterData(
        tabFilterData?.length > 0 && tabFilterData?.length < totalData
          ? tabFilterData?.concat(res.data.data)
          : res.data.data
      );
      setTotalData(res.data.total);
      setLoading(false);
    }, 1500);
  }

  const handleScroll = () => {
    if (
      Math.round(window.innerHeight) +
        Math.round(document.documentElement.scrollTop) !==
      Math.round(document.documentElement.offsetHeight)
    ) {
      if (
        document.documentElement.offsetHeight -
          (window.innerHeight +
            Math.round(document.documentElement.scrollTop)) <=
        1
      ) {
        if (tabFilterData?.length < totalData && !loading) {
          setCurrentPage(currentPage + 1);
          getProviders(currentPage + 1, window.scrollX, window.scrollY);
        }
      } else {
        return;
      }
    } else {
      if (tabFilterData?.length < totalData && !loading) {
        setCurrentPage(currentPage + 1);
        getProviders(currentPage + 1, window.scrollX, window.scrollY);
      }
    }
  };

  //console.log("TEST", tabFilterData?.length, totalData, !loading);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading]);

  useEffect(() => {
    async function getProviders() {
      setLoading(true);
      Reset();
      let paramRule = {
        keyword: searchText,
        sortKey: sort.sortKey,
        sortOrder: sort.sortOrder,
        index: activeTab.index,
      };
      let res = await axios.post(
        `/admin/loan/provider/list/${pageSize}/${currentPage}`,
        { [activeTab.parameter]: activeTab.value, ...paramRule }
      );
      setItems(res.data.data);
      setTabData(res.data.counts);
      setTotalData(res.data.total);
      setTabFilterData(res.data.data);
      setLoading(false);
    }
    getProviders();
  }, [activeTab, sort]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchText && searchText.length > 1) getProviders();
      else if (searchText === "") getProviders();
    }, 500);
    return () => clearTimeout(timer);
    async function getProviders() {
      setLoading(true);
      let res = await axios.post(
        `/admin/loan/provider/list/${pageSize}/${currentPage}`,
        {
          [activeTab.parameter]: activeTab.value,
          keyword: searchText,
          sortKey: sort.sortKey,
          sortOrder: sort.sortOrder,
          index: activeTab.index,
        }
      );
      setItems(res.data.data);
      setTabData(res.data.counts);
      setTabFilterData(res.data.data);
      setTotalData(res.data.total);
      setLoading(false);
    }
  }, [searchText]);

  useEffect(() => {
    setAnchorEls(Array(tabFilterData?.length).fill(null));
  }, [tabFilterData]);

  const confirmFeatured = async (id, status) => {
    try {
      let itemData = tabFilterData.find((item) => item.id === id);
      let res = await axios.put(`/admin/loan/provider/update/${id}`, {
        ...itemData,
        featured: !status,
      });
      if (res.data.resp_code) {
        setCurrentPage(1);
        setTabFilterData([]);
        await getProviders(1, window.scrollX, window.scrollY);
        setFeatureModal((data) => ({
          ...data,
          id: null,
          status: null,
          show: false,
        }));
      } else throw { response: "Invalid response" };
    } catch (error) {
      alert(error.response.data.errors);
    }
  };

  const confirmInactive = async (id, status) => {
    try {
      let itemData = tabFilterData.find((item) => item.id === id);
      let res = await axios.put(`/admin/loan/provider/update/${id}`, {
        ...itemData,
        status: status === 1 ? 0 : 1,
      });
      if (res.data.resp_code) {
        setCurrentPage(1);
        setTabFilterData([]);
        await getProviders(1, window.scrollX, window.scrollY);
        setInactiveModal((data) => ({
          ...data,
          id: null,
          status: null,
          show: false,
        }));
      } else throw { response: "Invalid response" };
    } catch (error) {
      alert(error.response.data.errors);
    }
  };

  const confirmDelete = async (id) => {
    try {
      let res = await axios.delete(`/admin/loan/provider/delete/${id}`);
      if (res.data.resp_code === 200) {
        setCurrentPage(1);
        setTabFilterData([]);
        await getProviders(1, window.scrollX, window.scrollY);
        setDeleteModal(false);
      } else throw { response: "Invalid response" };
    } catch (error) {
      alert(error.response.data.errors);
    }
  };

  const handleOpenMenu = (index, event) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
    setMenuOpen(true);
  };
  const handleCloseMenu = () => {
    setAnchorEls(Array(tabFilterData.length).fill(null));
    setMenuOpen(false);
  };
  const onFeatureClick = async (id, status) => {
    setFeatureModal((data) => ({
      ...data,
      id: id,
      status: status,
      show: true,
    }));
  };
  const onInactiveClick = async (id, status) => {
    setInactiveModal({
      id: id,
      status: status,
      show: true,
    });
  };
  const onDeleteClick = async (id) => {
    setDeleteModal({ id: id, show: true });
  };

  const SetLoanProviderFilters = (data) => {
    Reset();
    setActiveTab(data);
    dispatch(setFilters(data));
  };

  const HandleSort = (value) => {
    Reset();
    setSort(value);
  };
  const HandleSearch = (val) => {
    Reset();
    setSearchText(val);
  };

  return (
    <div className="flex-1 bg-[#F5F5F5] w-[100%] min-h-screen">
      <PrimaryHeader
        sort={sort}
        setSort={HandleSort}
        searchText={searchText}
        setSearchText={HandleSearch}
        title={"Manage Loan Providers"}
        activeTab={activeTab}
        setActiveTab={SetLoanProviderFilters}
        btnTitle={"Create Loan Provider"}
        tabData={tabData}
        setShowModal={setShowManageModal}
        pagePermission={pagePermission}
      />
      <div className="p-[50px_25px]">
        {!loading ? (
          <div className="flex flex-wrap gap-[35px_20px]">
            {[...tabFilterData].map((item, index) => (
              <ProviderGridItem
                anchorEl={anchorEls[index]}
                menuOpen={menuOpen && anchorEls[index] !== null}
                handleOpenMenu={handleOpenMenu}
                handleCloseMenu={handleCloseMenu}
                index={index}
                key={index}
                data={item}
                onFeatureClick={onFeatureClick}
                onDeleteClick={onDeleteClick}
                onInactiveClick={onInactiveClick}
                onEditClick={setShowUpdateModal}
                currentTab={activeTab}
                pagePermission={pagePermission}
              />
            ))}
          </div>
        ) : (
          <LoaderComp />
        )}
      </div>
      {showManageModal ? (
        <CreateModal
          getProviders={getProviders}
          active={showManageModal}
          setActive={setShowManageModal}
          setItems={setItems}
          setShowUpdateModal={setShowUpdateModal}
          setTabFilterData={setTabFilterData}
          setCurrentPage={setCurrentPage}
        />
      ) : null}
      {showUpdateModal ? (
        <CreateModal
          getProviders={getProviders}
          active={showUpdateModal}
          setActive={setShowUpdateModal}
          update={true}
          setTabFilterData={setTabFilterData}
          setCurrentPage={setCurrentPage}
        />
      ) : null}
      {featureModal.show ? (
        <ConfirmationPopup
          type={"feature"}
          setActiveData={setFeatureModal}
          activeData={featureModal}
          onConfirm={confirmFeatured}
        />
      ) : null}
      {inactiveModal.show ? (
        <ConfirmationPopup
          type={"inactive"}
          setActiveData={setInactiveModal}
          activeData={inactiveModal}
          onConfirm={confirmInactive}
        />
      ) : null}
      {deleteModal.show ? (
        <ConfirmationPopup
          type={"delete"}
          setActiveData={setDeleteModal}
          activeData={deleteModal}
          onConfirm={confirmDelete}
        />
      ) : null}
    </div>
  );
}

const CreateModal = ({
  active,
  setActive,
  setItems,
  update,
  getProviders,
  setTabFilterData,
  setCurrentPage,
}) => {
  const [createData, setCreateData] = useState(
    update
      ? active
      : { icon: null, name: "", type: "", approvalTime: "", ltv: "" }
  );
  const [image, setImage] = useState(null);
  const [showCrop, setShowCrop] = useState(false);
  const [croppedImage, setCroppedImage] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const settings = useSelector((state) => state.settings);
  //console.log("settings", settings);
  const [errors, setErrors] = useState([]);
  const [updateMode, setUpdateMode] = useState(
    update !== undefined && update !== null ? update : false
  );
  const [file, setFile] = useState("");
  //console.log("updatssdsdse", active, updateMode);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      setCreateData((data) => ({ ...data, icon: null }));
      setShowCrop(true);
      setImage(URL.createObjectURL(event.target.files[0]));
      setFile(event.target.files[0]);
    }
  };

  const OnCancel = () => {
    setCreateData((data) => ({ ...data, icon: null }));
    setShowCrop(false);
    setImage(null);
    setCroppedImage("");
  };

  const onSubmit = async (e) => {
    if (updateMode) {
      try {
        e.preventDefault();
        let blobFile = await dataURItoBlob(croppedImage);
        let formData = new FormData();
        formData.append("file", blobFile, "crop-icon.jpg");
        formData.append("module", "loanproviders");

        let fileRes = await axios.post("/admin/upload/image", formData);
        let res = await axios.put(
          `/admin/loan/provider/update/${
            active.id !== undefined && active.id !== null
              ? active.id
              : createData.id
          }`,
          {
            ...createData,
            icon: createData.icon ? createData.icon : fileRes.data.data,
          }
        );
        if (res.data.resp_code) {
          setCurrentPage(1);
          toast.success(res.data.message);
          setCreateData((data) => ({
            ...data,
            icon: !data.icon ? fileRes.data.data : data.icon,
          }));
          setViewMode(true);
          //setActive(false);
          setTabFilterData([]);
          await getProviders(1, window.scrollX, window.scrollY);
        } else throw { response: "Invalid response" };
      } catch (error) {
        setErrors(error.response.data.errors);
      }
    } else {
      try {
        e.preventDefault();
        let blobFile = await dataURItoBlob(croppedImage);
        let formData = new FormData();
        formData.append("file", blobFile, "crop-icon.jpg");
        formData.append("module", "loanproviders");

        let fileRes = await axios.post("/admin/upload/image", formData);
        let res = await axios.post(`/admin/loan/provider/create`, {
          ...createData,
          icon: fileRes.data.data,
        });
        if (res.data.resp_code) {
          setCurrentPage(1);
          toast.success(res.data.message);
          setCreateData(res.data.data);
          setViewMode(true);
          await getProviders(1, window.scrollX, window.scrollY);
        } else throw { response: "Invalid response" };
      } catch (error) {
        setErrors(error.response.data.errors);
      }
    }
  };

  return (
    <>
      <OffCanvasModal
        title={
          updateMode
            ? "Update loan provider"
            : viewMode
            ? "Loan Provider"
            : "Create Loan Provider"
        }
        active={active}
        setActive={setActive}
      >
        <form onSubmit={onSubmit} className="w-full">
          {updateMode && (
            <div className="grid grid-cols-2 gap-x-3 gap-y-4 mb-4">
              <div className="col-span-1 sm: md:col-span-1">
                <label>Created On</label>
                <p class="md:text-sm text-black ">
                  {Moment(createData.created_at).format("DD-MM-YYYY HH:MM")}
                </p>
              </div>
              <div className="col-span-1 sm: md:col-span-1">
                <label>Updated On</label>
                <p class="md:text-sm text-black ">
                  {Moment(createData.updated_at).format("DD-MM-YYYY HH:MM")}
                </p>
              </div>
            </div>
          )}
          <div className="grid grid-cols-3 gap-x-3 gap-y-4">
            <div className="col-span-1 sm: md:col-span-1">
              <label>Loan Provider Logo</label>
              {viewMode ? (
                <img
                  src={
                    createData.icon
                      ? `${IMAGE_BASE_URL}/${createData.icon}`
                      : croppedImage
                  }
                  className="h-5 w-5 rounded-md"
                />
              ) : (
                <ImageInput
                  viewMode={viewMode}
                  image={
                    update &&
                    createData.icon &&
                    createData.icon !== "" &&
                    createData.icon !== null
                      ? `${IMAGE_BASE_URL}/${createData.icon}`
                      : croppedImage
                  }
                  setImage={onImageChange}
                  error={errors ? errors["icon"] : null}
                  file={file}
                />
              )}
            </div>
            <div className="col-span-2 md:col-span-2">
              <label>Loan Provider Name</label>
              <Input
                required={true}
                viewMode={viewMode}
                type="text"
                error={errors ? errors["name"] : null}
                placeholder="Enter loan provider name"
                value={createData.name}
                setValue={(value) =>
                  setCreateData((data) => ({ ...data, name: value }))
                }
              />
            </div>
            <div className="col-span-3 md:col-span-1">
              <label>Type</label>
              {viewMode ? (
                <p className="text-sm text-black">
                  {getNameFromSettings(
                    settings,
                    SETTINGS_LOAN_PROVIDERS_LIST,
                    createData.type
                  )}
                </p>
              ) : (
                <CustomSelect
                  required={true}
                  disabled={viewMode}
                  placeholder={"Select Type"}
                  options={settings[SETTINGS_LOAN_PROVIDERS_LIST]}
                  value={createData.type}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, type: value }))
                  }
                  error={errors ? errors["type"] : null}
                />
              )}
            </div>
            <div className="col-span-3 md:col-span-1">
              <label>Approval Time</label>
              {viewMode ? (
                <p className="text-sm text-black">
                  {getNameFromSettings(
                    settings,
                    SETTINGS_APPROVAL_TIME_LIST,
                    createData.approvalTime
                  )}
                </p>
              ) : (
                <CustomSelect
                  required={true}
                  disabled={viewMode}
                  placeholder={"Select Approval Time"}
                  options={settings[SETTINGS_APPROVAL_TIME_LIST]}
                  value={createData.approvalTime}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, approvalTime: value }))
                  }
                  error={errors ? errors["approvalTime"] : null}
                />
              )}
            </div>
            <div className="col-span-3 md:col-span-1">
              <label>Loan To Value</label>
              {viewMode ? (
                <p className="text-sm text-black">
                  {getNameFromSettings(
                    settings,
                    SETTINGS_LTV_LIST,
                    createData.ltv
                  )}
                </p>
              ) : (
                <CustomSelect
                  required={true}
                  disabled={viewMode}
                  placeholder={"Select Loan To Value"}
                  options={settings[SETTINGS_LTV_LIST]}
                  value={createData.ltv}
                  setValue={(value) =>
                    setCreateData((data) => ({ ...data, ltv: value }))
                  }
                  error={errors ? errors["ltv"] : null}
                />
              )}
            </div>
            <div>
              <label>Listing Type</label>
              <button
                type="button"
                disabled={viewMode}
                className={`px-3 mt-1 py-2 rounded-[5px] text-sm font-medium ${
                  createData.featured
                    ? "bg-blue-200 text-blue-700"
                    : "bg-gray-200 text-gray-600"
                }`}
                onClick={() =>
                  setCreateData((data) => ({
                    ...data,
                    featured: !data.featured,
                  }))
                }
              >
                Featured
              </button>
            </div>
          </div>
          <div className="flex mt-10">
            {viewMode ? (
              <a
                className="btn-md capitalize cursor-pointer"
                type={"button"}
                onClick={() => {
                  //console.log("createData", createData);
                  setViewMode(false);
                  setUpdateMode(true);
                }}
              >
                Edit
              </a>
            ) : (
              <button className="btn-md capitalize" type={"submit"}>
                {updateMode ? "Update Loan provider" : "Create loan provider"}
              </button>
            )}
            <button
              className="ml-4 btn-md-disabled"
              onClick={() => setActive(false)}
            >
              {viewMode ? "Close" : "Cancel"}
            </button>
          </div>
        </form>
      </OffCanvasModal>
      {showCrop ? (
        <CropPopup
          image={image}
          setActive={setShowCrop}
          setImage={setCroppedImage}
          OnCancel={OnCancel}
        />
      ) : null}
    </>
  );
};
